/* eslint-disable */
export default {
  notActivated: 'Inactive',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
